import { lazy } from 'solid-js'
import { messages } from '../../pages/properties-page/properties-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/properties-page/properties-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/properties',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
